import * as React from 'react';
import { XingFrameContext } from '@xingternal/xing-frame-provider';
const wrapSingleElementIntoArray = (elementOrArray) => Array.isArray(elementOrArray) ? elementOrArray : [elementOrArray];
const matchAll = (features, flagsArray) => {
    return flagsArray.every((flag) => features[flag]);
};
const matchAny = (features, flagsArray) => {
    return flagsArray.some((flag) => features[flag]);
};
export const FeatureCondition = ({ children = null, elseCase = null, flags, matchMode, }) => {
    const { features } = React.useContext(XingFrameContext);
    const flagsArray = wrapSingleElementIntoArray(flags);
    const matcher = matchMode === 'and' ? matchAll : matchAny;
    const matches = matcher(features, flagsArray);
    return React.createElement(React.Fragment, null, matches ? children : elseCase);
};
//# sourceMappingURL=feature-condition.js.map